import React, { useCallback, useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import * as Yup from "yup";
import { useFormik } from "formik";
import TextInput from "../../common/textfield/TextInput";
import SelectFiled from "../../common/textfield/SelectFiled";
import { useNavigate } from "react-router-dom";
import { Button } from "../../common/Button";
import { failed, success } from "../../common/Toastify";
import { encryptData } from "../../EncryptDecrypt";
import {
  createAccountOptions,
  caregions,
  usregions,
  countryList,
  FormikObjCreate,
} from "./Constants";
import { useOrgQuery } from "../../../hooks/ReactQueryHooks/useOrgQuery";
import { Skeleton, Tooltip } from "@mui/material";
import {
  createUser,
  getPractitionerList,
} from "../../api/Individual";
import { useClinicLocationsQuery } from "../../../hooks/ReactQueryHooks/useClinicLocationsQuery";
import { Clear, InfoOutlined } from "@mui/icons-material";
import moment from "moment";
import {
  createContactNumber,
} from "../../../utils/phoneNumberSupport";
import { useSelector } from "react-redux";
import Fields from "./Fields";
import { useOrgHcnQuery } from "../../../hooks/ReactQueryHooks/useOrgHcnQuery";
import { getOrganizationSettings } from "../../api/Organization";
import { useGetOrgLicensedProducts } from "../../../hooks/ReactQueryHooks/useGetOrgLicensedProducts";

function CreatePatient() {
  const navigate = useNavigate();
  const onSuccessLocations = (data) => {
    setLocations(
      data?.map((location) => (location = { ...location, value: location?.id }))
    );
  };
  useClinicLocationsQuery({ onSuccess: onSuccessLocations });
  const [locations, setLocations] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [organizations, setOrganizations] = useState([]);
  const [organizationsData, setOrganizationsData] = useState([]);
  const [hcnList, setHcnList] = useState([]);
  //For Setting scope of jurisdictions
  const [regionOptions, setRegionOptions] = useState([]);
  //For selecting role and showing jurisdictions
  const [roleSelected, setRoleSelected] = useState(false);
  //For selecting org and showing roles  of that org
  const [orgSelected, setOrgSelected] = useState(false);

  const [typeStatus, setTypeStatus] = useState(false);
  const user = useSelector((state) => state?.auth?.user);
  const isAdmin = user?.["cognito:groups"]?.includes("Super-Admin");
  const adminOrgs = useSelector((state) => state?.auth?.user?.organizations)
  
  const orgId = useSelector( (state) => state?.auth?.user?.organizations?.[0]?.id );
  const [selectedOrgId, setSelectedOrgId] = useState(orgId);
  const { data: orgLicensedProducts } = useGetOrgLicensedProducts({})
  const is_VirtualCareEnabled = orgLicensedProducts?.virtualCare
  const [createAccount, setCreateAccount] = useState(is_VirtualCareEnabled ? true : false);
  const [createAccountValue, setCreateAccountValue] = useState(is_VirtualCareEnabled ? true : false);
  const [enforceHCN, setEnforceHCN] = useState(false);
  const [enforceEmail, setEnforceEmail] = useState(false);
    const [enforcePhoneNumber, setEnforcePhoneNumber] = useState(false);
    const [enforceAddress, setEnforceAddress] = useState(false);
    const [enforceCountry, setEnforceCountry] = useState(false);
    const [enforceProvince, setEnforceProvince] = useState(false);
    const [enforceCity, setEnforceCity] = useState(false);
    const [enforcePostalCode, setEnforcePostalCode] = useState(false);
    const [enforceDOB, setEnforceDOB] = useState(false);
    const [enforceGender, setEnforceGender] = useState(false);
    const [enforceFirstName, setEnforceFirstName] = useState(false);
    const [enforceLastName, setEnforceLastName] = useState(false);
    const [loading, setLoading] = useState(false);


  //Fetching Organization Data
  const onSuccessOrg = (data) => {
    setOrganizations(data?.map((org) => (org = { ...org, value: org?.id })));
    setOrganizationsData(data);
  };
  const { isLoading } = useOrgQuery({ onSuccess: onSuccessOrg });

  const onSuccessHcn = (data) => {
    const hcnOptions = data
      ?.filter((hcn) => hcn.active)  
      .sort((a, b) => a.description.localeCompare(b.description))
      .map((hcn) => ({
        ...hcn,
        value: hcn.authority === "#" ? `test-authority-${hcn.id}` : hcn.authority,
        name: hcn.display || hcn.description,
      }));

    setHcnList(hcnOptions);
  };
  useOrgHcnQuery({ onSuccess: onSuccessHcn, orgId:selectedOrgId });

    useEffect(() => {
      if (!selectedOrgId) return;
      setLoading(true);
      getOrganizationSettings(selectedOrgId)
        .then((res) => {
          if (res?.status) {
            const p = res.data?.patient || {};
            setEnforceHCN(!!p.hcn);
            setEnforceEmail(!!p.email);
            setEnforcePhoneNumber(!!p.phone);
            setEnforceCountry(!!p.country);
            setEnforceProvince(!!p.province);
            setEnforceCity(!!p.city);
            setEnforceFirstName(!!p.firstName);
            setEnforceLastName(!!p.lastName);
            setEnforceGender(!!p.gender);
            setEnforceDOB(!!p.dob);
            setEnforcePostalCode(!!p.postalCode);
            setEnforceAddress(!!p.address);
          }
        })
        .catch((res) => {
          failed(
            res?.response?.data?.message ||
              res?.response?.data?.error ||
              res.message
          );
        })
        .finally(() => setLoading(false));
    }, [selectedOrgId]);

  const handleOrgChange = (event) => {
    const value = event?.target?.value;
    setOrgSelected(true);
    formik.setFieldValue("organization", value);
    setSelectedOrgId(value);
  };


  const handleCountryChange = (event) => {
    const value = event?.target?.value;
    if (value === "CA") {
      setRegionOptions(caregions);
    } else {
      setRegionOptions(usregions);
    }
    formik.setFieldValue("countrylist", value);
    if (formik?.values?.type === "Kiosk Device") {
      formik.setFieldValue("country", value);
    }
    formik.setFieldValue("jurisdiction", []);
  };

  const handleRelationshipChange = (event) => {
    formik.setFieldValue("relationship", event?.target?.value);
  };

  const formik = useFormik({
    ...FormikObjCreate,
    initialValues: {
      ...FormikObjCreate.initialValues,
      type:  "Patient",
    },
    validationSchema: Yup.object({
      first_name: enforceFirstName ? 
      Yup.string()
        .max(50, "Must be 50 characters or less")
        .required("Required first name field")
        .matches(/^$|^\S+.*/, "Only blankspaces is not valid.")
      : Yup.string()
        .max(50, "Must be 50 characters or less")
        .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
    
      last_name: enforceLastName ? 
      Yup.string()
        .max(50, "Must be 50 characters or less")
        .required("Required last name field")
        .matches(/^$|^\S+.*/, "Only blankspaces is not valid.")
      : Yup.string()
        .max(50, "Must be 50 characters or less")
        .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
    
      qualification: Yup.string()
        .max(50, "Must be 50 characters or less")
        .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
    
      license: Yup.string()
        .max(20, "Must be 20 characters or less")
        .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
    
     date_of_birth: enforceDOB
      ? Yup.string()
          .required("Required date of birth field")
          .nullable()
          .test(
            "valid-format",
            "Invalid format. Use MMM-DD-YYYY (JAN-01-2024).",
            function (value) {
              if (value) { 
                const isValid1 = moment(value, "MM/DD/YYYY", true).isValid();
                const isValid2 = moment(value, "MM-DD-YYYY", true).isValid();
                if (!isValid1 && !isValid2) return false; 
                const dob = isValid1 ? moment(value, "MM/DD/YYYY") : moment(value, "MM-DD-YYYY"); 
                
                if (dob.isAfter(moment())) {
                  return this.createError({
                    message: "Date of birth cannot be in the future.",
                  });
                }
                let minDate = moment().subtract(125, "years");
                if (dob.isBefore(minDate)) {
                  return this.createError({
                    message: "Date of Birth cannot be more than 125 years ago.",
                  });
                } 
              }
              return true;
            }
          )
      : Yup.string()
          .nullable()
          .test(
            "valid-format",
            "Invalid format. Use MMM-DD-YYYY (JAN-01-2024).",
            function (value) {
              if (!value) return true; 
              const isValid1 = moment(value, "MM/DD/YYYY", true).isValid();
              const isValid2 = moment(value, "MM-DD-YYYY", true).isValid();
              if (!isValid1 && !isValid2) return false; 
              const dob = isValid1 ? moment(value, "MM/DD/YYYY") : moment(value, "MM-DD-YYYY"); 
              if (dob.isAfter(moment())) {
                return this.createError({
                  message: "Date of birth cannot be in the future.",
                });
              }
              let minDate = moment().subtract(125, "years");
              if (dob.isBefore(minDate)) {
                return this.createError({
                  message: "Date of Birth cannot be more than 125 years ago.",
                });
              } 
              return true;
            }
          ),

    
      phone_number: enforcePhoneNumber
              ? Yup.string()
                  .required("Required phone number field")
                  .matches(
                    /^(?:\+?1[-. ]?)?\(?\d{3}\)?[-. ]?\d{3}[-. ]?\d{4}$/,
                    "Enter Valid Phone Number."
                  )
              : Yup.string().test(
                  "is-valid-or-empty-placeholder",
                  "Enter Valid Phone Number.",
                  (value) => {
                    if (!value) return true; // allow empty
                    if (value.trim() === "(___) ___-____") return true; // allow placeholder
                    return /^(?:\+?1[-. ]?)?\(?\d{3}\)?[-. ]?\d{3}[-. ]?\d{4}$/.test(value);
                  }
            ),

      home_phone_number: Yup.string().matches(
        /^(?:\+?1[-. ]?)?\(?[0-9]\d{2}\)?[-. ]?\d{3}[-. ]?\d{4}$/,
        "Enter Valid Home Phone Number."
      ),
    
      ext: Yup.string().matches(/^\d{0,4}$/, "Must be 4 digits or less."),
    
      address: enforceAddress ? Yup.string()
        .required("Required address field")
        .matches(/^$|^\S+.*/, "Only blankspaces is not valid."):
        Yup.string()
        .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
    
      city: enforceCity ? Yup.string()
        .required("Required city field")
        .matches(/^$|^\S+.*/, "Only blankspaces is not valid.") :
        Yup.string()
        .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
    
      email: enforceEmail ? Yup.string().when("create_account", (type, schema) =>
          createAccountValue
          ? schema
            .email("Invalid email address")
            .required("Required email field")
            .matches(/^$|^\S+.*/, "Only blankspaces is not valid.")
          : schema
          .email("Invalid email address")
          .required("Required email field")
      ) : Yup.string().when("create_account", (type, schema) =>
          createAccountValue
          ? schema
            .email("Invalid email address")
            .required("Required email field")
            .matches(/^$|^\S+.*/, "Only blankspaces is not valid.")
          : schema
          .email("Invalid email address")
      ),
    
      type: Yup.string()
        .required("Required type field")
        .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
    
      organization: Yup.string()
        .required("Required organization")
        .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
    
      gender: enforceGender ? Yup.string()
        .required("Required gender field")
        .matches(/^$|^\S+.*/, "Only blankspaces is not valid."):
        Yup.string(),
    
      country: enforceCountry ? Yup.string()
        .required("Required country field")
        .matches(/^$|^\S+.*/, "Only blankspaces is not valid.") :
        Yup.string(),

      region: enforceProvince ? Yup.string()
        .required(`Required field`)
        .matches(/^$|^\S+.*/, "Only blankspaces is not valid.") : Yup.string(),
    
      role: Yup.string().when("type", (type, schema) =>
        typeStatus ? schema.required("Required Role field") : schema
      ),
    
      create_account: Yup.string().when("type", (type, schema) =>
        createAccount ? schema.required("Required Create Account field") : schema
      ),
    
      countrylist: Yup.array().when("role", (role, schema) =>
        role && roleSelected ? schema.required("Required Country field") : schema
      ),
    
      jurisdiction: Yup.array().when("role", (role, schema) =>
        role && roleSelected
          ? schema
              .min(1, "Required Jurisdictions field")
              .required("Required Jurisdictions field")
          : schema
      ),
    
      relationship: Yup.string().when(
        ["related_to", "type"],
        (related_to, type, schema) =>
          related_to && type === "Related_Person"
            ? schema.required("Required Relationship field")
            : schema
      ),
    
      related_to: Yup.string().when("type", (type, schema) =>
        type === "Related_Person"
          ? schema.required("Required Related To field")
          : schema
      ),
    
      postalCode: enforcePostalCode ? Yup.string().when(["type", "country"], (type, country, schema) =>
        country === "US"
          ? Yup.number()
              .typeError("Zip code must be a number")
              .required("Required field")
          : Yup.string()
              .required("Required field")
              .matches(
                /^[A-Za-z]\d[A-Za-z] [0-9][A-Za-z]\d$/,
                "Postal code must be in A1A 1A1 format."
              )
      ) : Yup.string().when(["type", "country"], (type, country, schema) =>
        country === "US"
          ? Yup.number()
              .typeError("Zip code must be a number")
          : Yup.string()
              .matches(
                /^[A-Za-z]\d[A-Za-z] [0-9][A-Za-z]\d$/,
                "Postal code must be in A1A 1A1 format."
              )
      ),
      hcn: enforceHCN ? Yup.string().when("type", (type, schema) =>
        type === "Patient"
          ? schema.matches(/^\d+$/, "Patient Identifier must contain only numbers").required("Patient Identifier is required")
          : Yup.string()) : Yup.string(), 
      healthCardAuthority: Yup.string().when("hcn", {
        is: (hcn) => hcn && hcn.length > 0,
        then: (schema) => schema
          .required("Identifier Type is required when Patient Identifier is provided")
          .matches(/^\S+.*/, "Only blankspaces is not valid."),
      }),    
      // hcn: enforceHCN ? Yup.string().when("type", (type, schema) =>
      //   type === "Patient"
      //     ? schema.required("Patient Identifier is required when creating a patient.")
      //     : schema
      // ) : Yup.string(),

      // healthCardAuthority:enforceHCN ? Yup.string()
      //   .required("Required Identifier Type")
      //   .matches(/^$|^\S+.*/, "Only blankspaces is not valid.") : Yup.string(),
    }),
    

    onSubmit: (values) => {
      const type = values?.type;
      const state = values?.country + "-" + values?.region;
      const dob = encryptData(moment(values?.date_of_birth).format("MM-DD-YYYY"))
      let phoneNumber = createContactNumber(values);
      let encryptedData = {
        first_name: encryptData(values?.first_name.toLowerCase()),
        last_name: encryptData(values?.last_name.toLowerCase()),
        full_name: encryptData(
          [
            values?.first_name.toLowerCase(),
            values?.last_name.toLowerCase(),
          ].join(" ")
        ),
        address: encryptData(values?.address),
        date_of_birth: (dob !== "Invalid date") ? dob : "",
        phone_number: encryptData(phoneNumber),
        postalCode: encryptData(values?.postalCode.toUpperCase()),
        city: encryptData(values?.city),
        gender: encryptData(values?.gender),
        email: encryptData(values?.email?.toLowerCase()),
        relationship: encryptData(values?.relationship),
        healthCardNumber: encryptData(values?.hcn),
        device_name: encryptData(values?.device_name),
        healthCardAuthority: values?.healthCardAuthority
      };
      setBtnLoading(true);
      const selectedLocationData =
        locations?.filter(
          (location) => location?.id === values?.clinic_location
        )?.[0] || null;

      createUser(
        values,
        encryptedData,
        organizationsData,
        state,
        type,
        [],
        selectedLocationData,
        adminOrgs?.[0]?.id
      )
        .then((res) => {
          if (res.status === true) {
            navigate("/app/identities/patients");
            success(res.message);
          } else {
            failed(res.error);
          }
        })
        .catch((res) => {
          failed(
            res?.response?.data?.message ||
            res?.response?.data?.error ||
            res.message
          );
        })
        .finally(() => setBtnLoading(false));
        
    },
  });

 
  const handleCreateAccountChange = useCallback((event) => {
    const value = event?.target?.value; 
    if (value == "true") { 
      setCreateAccountValue(true);
    }
    else{ 
      setCreateAccountValue(false);
    }   
    formik?.setFieldValue("create_account", value);
  }, [formik, setCreateAccountValue]); 

  const handleFormChange = (e) => {
    if (e?.target?.id === "region" || e?.target?.id === "organization") {
      const selected_region =
        e?.target?.id === "region" ? e?.target?.value : formik?.values?.region;
      const selected_org =
        e?.target?.id === "organization"
          ? e?.target?.value
          : formik?.values?.organization;
    } else if (e?.target?.id === "country") {
      formik.setFieldValue("region", "");
      formik.setFieldValue("postalCode", "");
    }
  };

  const handlePostalCodeChange = (e) => {
    const { value } = e.target;
    let spacedValue = value;
    if (formik?.values?.country !== "US") {
      // Remove spaces and non-alphanumeric characters
      const formattedValue = value.replace(/[^A-Za-z0-9]/g, "");
      // Add a space after every 3 letters
      spacedValue = formattedValue.replace(
        /^([A-Za-z0-9]{3})([A-Za-z0-9]+)/,
        "$1 $2"
      );
    }
    // Set the formatted value in the formik
    formik?.setFieldValue("postalCode", spacedValue);
  };

  const handleDesignationChange = (event) => {
    const value = event?.target?.value;
    const name = event?.target?.name;
    formik.setFieldValue("designation", value);
  };
  const handleExt = (event) => {
    let key = event.key;
    let regex = new RegExp("^[0-9]+$");
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
  };

  const genderOptions = [
      { value: "male", name: "Male" },
      { value: "female", name: "Female" },
      { value: "other", name: "Other" },
  ];

  const createBasicFields = [
      [{
          size: "3",
          fieldType: "TextInput",
          keyField: "first_name",
          label: "First Name",
          placeholder: "First Name",
          required: enforceFirstName,
          hideRequired: !enforceFirstName,
      },
      {
          size: "3",
          fieldType: "TextInput",
          keyField: "last_name",
          label: "Last Name",
          placeholder: "Last Name",
          required: enforceLastName,
          hideRequired: !enforceLastName,
      },
      {
          fieldType: "ReactDatePicker",
          keyField: "date_of_birth",
          label: "Date of Birth",
          placeholder: "Select Date",
          hasValue: "date_of_birth",
          displayAge: true,
          required: enforceDOB,
          hideRequired: !enforceDOB,
      },
      {
          fieldType: "SelectFiled",
          keyField: "gender",
          label: "Select Gender",
          options: genderOptions,
          required: enforceGender,
          hideRequired: !enforceGender,
      },
      ],
      [
          {
              size: "12",
              fieldType: "TextInput",
              keyField: "address",
              label: "Address",
              placeholder: "Address",
              required: enforceAddress,
              hideRequired: !enforceAddress,
          }
       ],
      [
      {
          size: "6",
          fieldType: "CountrySelect",
          keyField: "country",
          label: "Country",
          required: enforceCountry,
          hideRequired: !enforceCountry,
      },
      {
          size: "6",
          fieldType: "RegionSelect",
          keyField: "region",
          required: enforceProvince,
          hideRequired: !enforceProvince,
      }
  ],
  [
      {
          size: "6",
          fieldType: "TextInput",
          keyField: "city",
          label: "City",
          placeholder: "City",
          required: enforceCity,
          hideRequired: !enforceCity,
      },
      {
          size: "6",
          fieldType: "postalCode",
          required: enforcePostalCode,
          hideRequired: !enforcePostalCode,
      }
  ]
  ];

  return (
    <section className="common-listing">
      <div className="heading-wrap mb-3">
        {/* <Tooltip title="Go back">
          <div
            style={{ marginRight: "1rem", cursor: "pointer" }}
            onClick={() => navigate(-1)}
          >
            <ArrowBack />
          </div>
        </Tooltip> */}
      </div>
      <div className="custom-card p-4">
        <form
          className="common-form border-fields userAccount"
          onSubmit={formik.handleSubmit}
          onChange={handleFormChange}
        >
          <Row>
            {isLoading ? (
              <Col>
                <Skeleton animation="wave" />
              </Col>
            ) : (
              <Col md={3}>
                {formik?.values?.type !== "Super-Admin" ? (
                  <SelectFiled
                    keyField={"organization"}
                    label={"Select Organization"}
                    formik={formik}
                    options={organizations}
                    onChange={handleOrgChange}
                  />
                ) : null}
              </Col>
            )}
            {  (createAccount && is_VirtualCareEnabled) ? (
              <Col>
                <div style={{ display: "flex", flexDirection: "row", gap: "8px" }}>
                    <SelectFiled
                    keyField={"create_account"}
                    label={"Create Account"}
                    formik={formik}
                    placeholder={"Create Account"}
                    options={createAccountOptions}
                    onChange={handleCreateAccountChange}
                  />
                  { createAccountValue && <div>
                    <Tooltip title="If `Yes` is selected, the patient's email becomes mandatory. A temporary password will be sent to the provided email for mobile app access." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
                        <InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
                    </Tooltip>
                  </div>
                  }
                </div>
              </Col>
            ) : (
              <>
                <Col></Col>
                <Col></Col>
              </>
            )}
            <Col style={{display:"flex", placeContent: "flex-end"}}>
                  <Tooltip style={{}}>
                    <div
                      style={{ marginRight: "1rem", cursor: "pointer",maxHeight: "24px" }}
                      onClick={() => navigate(-1)}
                    >
                      <Clear />
                    </div>
                  </Tooltip>
            </Col>
          </Row>
          <Fields fields={createBasicFields} formik={formik} isReadOnly={false} handlePostalCodeChange={handlePostalCodeChange} />
          <Row>
            <Col  sm lg = "4">
              <TextInput
                keyField={"email"}
                label={"Email Address"}
                formik={formik}
                placeholder={"Email Address"}  
                hideRequired= {true}
                required={enforceEmail}
              />
            </Col>
            <Col sm lg = "4">
              <TextInput
                keyField={"phone_number"}
                type="phone"
                label={"Phone Number"}
                formik={formik}
                placeholder={"Phone Number"}
                hideRequired= {!enforcePhoneNumber}
                required={enforcePhoneNumber}
              />
            </Col>
            {formik.values.phone_number && (
              <Col sm lg = "2">
                <TextInput
                  keyField={"ext"}
                  label={"Ext."}
                  type="text"
                  maxlength="4"
                  formik={formik}
                  placeholder={"Ext."}
                  hideRequired= {true}
                  onKeyPress={handleExt}
                  autocomplete="off"
                />
              </Col>
            )}
          </Row>

           
            <Row>
              <Col>
                <TextInput
                  keyField={"hcn"}
                  label={"Patient Identifier"}
                  formik={formik}
                  placeholder={"Patient Identifier"}
                  required={enforceHCN}
                  hideRequired={!enforceHCN}
                />
              </Col>
              <Col>
                <SelectFiled
                  keyField={"healthCardAuthority"}
                  label={"Identifier Type"}
                  formik={formik}
                  options={hcnList}
                  required={enforceHCN}
                  hideRequired={!enforceHCN}
                />
              </Col>
              <Col></Col>
            </Row>

          <div className="btn-wrap" style={{ display: "flex", gap: "16px" }}>
            <Button type="submit" isLoading={btnLoading}>
              Create
            </Button>
            <Button
              onClick={() => navigate("/app/identities/patients")}
              variant="secondary"
            >
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </section>
  );
}

export default CreatePatient;
